// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__s-OHV","modal":"Modal_modal__C+wMF","slide-down":"Modal_slide-down__Dvjhv"};